import React, { useEffect } from "react";
import { TableHeaderColumn, BootstrapTable } from "/src/component/table/BootstrapTable";

import Loading from "../../../component/Loading";
import { dataTableConfig } from "../../../config/config";
import { VISIT_PAGE } from "../../../config/lang";

import { call } from "../../../util/action";
import { dateFormat } from "../../../util/formatter";
import { getStore } from "../../../util/redux/store";
import { translate } from "../../../util/util";

const me = getStore().getState().me;

function Payments({ data }) {
  const [state, setState] = React.useState({ payments: "", loading: false });

  useEffect(() => {
    setState(prev => ({ ...prev, loading: true }));
    let url = `visits/${data.id}/payments_in_visit/`;

    call({ method: "GET", url }, response => {
      setState(prev => ({
        ...prev,
        payments: response,
        loading: false,
      }));
    });
  }, [data.id]);

  const getDateChange = (item, obj) => {
    if (!item) {
      return <span>-</span>;
    }

    let newDate = new Date(item);
    const date = dateFormat(newDate);
    return date;
  };

  const getTaskRowStatusClass = item => {
    if (!item.status) return;
    const str = item.status.toLowerCase();
    const result = str.replace(/ /g, "-");
    return result;
  };

  const getCounterpartyInfo = item => {
    if (!item) {
      return <span>-</span>;
    }
    return <span>{item.name}</span>;
  };

  const getStringReturn = item => {
    if (!item) {
      return <span>-</span>;
    }

    return <span>{item}</span>;
  };

  const getStringDebt = item => {
    if (!item?.name_of_the_document) {
      return <span>-</span>;
    }

    return <span>{item.name_of_the_document}</span>;
  };

  const prepareOrderFormat = item => {
    if (item === null || item === undefined) {
      return <span>-</span>;
    }
    return <span>{item} грн.</span>;
  };

  return (
    <>
      <div className="returns-task-tab-wrapper">
        {state?.payments ? (
          <>
            <BootstrapTable
              data={state.payments}
              version="4"
              striped
              hover
              bordered={false}
              pagination={false}
              search={false}
              multiColumnSearch={true}
              columnFilter={false}
              options={{ ...dataTableConfig }}
              className="themed-main-table-container"
              trClassName={row => `returns-task-tab-item ${getTaskRowStatusClass(row)}`}
              tableHeaderClass="primary">
              <TableHeaderColumn dataField="id" isKey width="60px">
                {translate(VISIT_PAGE, "orders_payment_id_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getCounterpartyInfo} dataField="counterparty" width="60px">
                {translate(VISIT_PAGE, "orders_popup_counterparty_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={prepareOrderFormat} dataField="amount" width="60px">
                {translate(VISIT_PAGE, "orders_payment_amount_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getStringDebt} dataField="debt" width="60px">
                {translate(VISIT_PAGE, "orders_payment_debt_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getStringReturn} dataField="comment" width="60px">
                {translate(VISIT_PAGE, "orders_popup_comment_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={(item, obj) => getDateChange(item, obj)} dataField="datetime" width="60px">
                {translate(VISIT_PAGE, "orders_return_crated_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="visit" width="60px">
                {translate(VISIT_PAGE, "orders_popup_visit_label", me.language)}
              </TableHeaderColumn>
            </BootstrapTable>
          </>
        ) : (
          <Loading loading={state.loading} />
        )}
      </div>
    </>
  );
}

export default Payments;
